/**
 * stores.js — which shop each Shopping item is bought from, learned from the log.
 */

import { NO_STORE_LABEL } from '../config/checklists';
import { normalizeName } from './names';

/** name → most-recent store, learned from the completion log (for auto-fill). */
export function learnedStores(log) {
  const byName = new Map();  // normName → { store, date }
  for (const l of log || []) {
    if (!l || !l.store) continue;
    const key = normalizeName(l.name);
    const prev = byName.get(key);
    if (!prev || (l.date || '') >= prev.date) byName.set(key, { store: l.store, date: l.date || '' });
  }
  const map = new Map();
  byName.forEach((v, k) => map.set(k, v.store));
  return map;
}

/** Sorted, de-duplicated store names (defaults + items + log) for the store autosuggest. */
export function knownStores(items, log, defaults = []) {
  const set = new Set(defaults);
  (items || []).forEach(i => { if (i.store) set.add(i.store); });
  (log || []).forEach(l => { if (l.store) set.add(l.store); });
  return [...set].filter(Boolean).sort((a, b) => a.localeCompare(b));
}

/** Group items by store → [store, items][]; the unassigned bucket sorts last. */
export function groupByStore(items, noStoreLabel = NO_STORE_LABEL) {
  const map = new Map();
  for (const i of items || []) {
    const s = (i.store || '').trim() || noStoreLabel;
    if (!map.has(s)) map.set(s, []);
    map.get(s).push(i);
  }
  return [...map.entries()].sort((a, b) => {
    if (a[0] === noStoreLabel) return 1;
    if (b[0] === noStoreLabel) return -1;
    return a[0].localeCompare(b[0]);
  });
}
